import * as bs58check from 'bs58check';

import { range } from '.';

export function Id(uniformRand: () => number = Math.random) {
  const randHex = () => '0123456789abcdef'[Math.floor(16 * uniformRand())];
  return bs58check.encode(Buffer.from(range(16).map(randHex).join(''), 'hex'));
}

export default Id;



// WEBPACK FOOTER //
// ./src/util/Id.ts